module.exports = __webpack_public_path__ + "img/1.624e11a3.jpg";